import { render, staticRenderFns } from "./medicalReport.vue?vue&type=template&id=b42c5c30&scoped=true&"
import script from "./medicalReport.vue?vue&type=script&lang=js&"
export * from "./medicalReport.vue?vue&type=script&lang=js&"
import style0 from "./medicalReport.vue?vue&type=style&index=0&id=b42c5c30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c5c30",
  null
  
)

export default component.exports